<template>
  <div>
        <div id="cf3" class="fadein">
            <img class="bottom" src="../assets/TAJimages/banner-bg3 1.png">
            <img class="top" src="../assets/TAJimages/banner-bg8.jpeg">
            <img class="fadein" src="../assets/TAJimages/banner-bg1.jpeg">
        </div>
        <div class="overlay"></div>
        <div class="main1 overall-body">
            <div class="container-fluid">
                <div class="container">
                    <div class="row justify-content-evenly  align-items-center" >
                        <div class="col-12 text-center text-sm-left mb-5">
                            <div class="animate__animated d-flex justify-content-between animate__fadeIn animate__delay-1s" >
                                <img src="../assets/TAJimages/tajbank 1-old.png" class="img-fluid taj-logo" alt="" style="margin-left:-30px;">
                                <img src="@/assets/TAJimages/NIFI-logo.png" alt="NIFI logo" class="nifi-logo img-fluid">
                            </div>
                        </div>
                        <div class="col-lg-8 col-sm-12 text-sm-center text-md-left animated fadeInLeft animate__delay-1s">
                          <div>
                              <h1 class="text-white login__header--text">
                                  Welcome to Retail Banking!
                              </h1>
                              <h5 class="text-white login__header--subtext">Login to access your profile</h5>
                          </div>
                          <div class="button-section d-flex flex-wrap">
                                <p @click="goToStep(9)" class="signup-btn">Sign Up</p>
                                <p @click="goToStep(2)" class="openaccount-btn">Open an Account</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-12 animated fadeInRight">
                            <div class="form-card">
                            <!-- login section -->
                                <div class="login__section">
                                    <form v-show="step === 1" class="text-center animated fadeIn theme-form form needs-validation" @submit.prevent="login" id="Submit_Form">
                                        <h2>Login</h2>
                                        <!-- <div class="line"></div> -->
                                        <hr class="line">
                                        <h3>Enter your details to proceed.</h3>
                                        <div class="form-body">
                                            <div class="textfield">
                                                <img src="../assets/TAJimages/SVG/user-1.svg" width="17px" height="19px" alt="">
                                                <div class="divider"></div>
                                                <input type="text" v-model="loginForm.username" id="UserName" name="UserName" placeholder="Enter Account No/Email/Phone No." required>
                                            </div>
                                            <div class="textfield">
                                                <img src="../assets/TAJimages/SVG/lock-1.svg" width="17px" height="19px" id="lock" alt="">
                                                <div class="divider"></div>
                                                <input :type="type" id="password" v-model="loginForm.password" name="password" placeholder="Enter Password" required>
                                                <img src="../assets/TAJimages/SVG/eye-1.svg" @click="showPassword" alt="" class="cursor-pointer">
                                            </div>
                                            <p class="forgot"><router-link class="red" style="text-decoration:none" to="/auth/forgot-password">Forgot Password?</router-link></p>
                                            <button class="button" :disabled="loading === true" :class="{'submit__btn': loading}" type="submit">
                                                <div v-if="loading" class='loader-box'>
                                                    <div class='loader-15'></div>
                                                </div>
                                                <div v-else>Submit</div>
                                            </button>
                                            <!--<p class="text-center">Don't have an account? <span @click="nextStep" class="account-btn">Sign Up</span></p> -->
                                        </div>
                                            <hr>
                                            <p class="mb-1">Contact Us:</p> 
                                            <p>
                                                <i class="fa fa-phone text-danger"></i> &nbsp;+234 908 793 7417 <i class="ml-2 fa fa-phone text-danger"></i> &nbsp;+234 700 825 2265<br>
                                                <a href="mailto:tajconnect@tajbank.com"><i class="fa fa-envelope text-danger"></i> &nbsp;tajconnect@tajbank.com</a>
                                            </p>
                                            <p class="copyright mt-3">© {{ new Date().getFullYear() }}. All Rights Reserved.</p>
                                    </form>
                                </div>
                                <!-- select sign up option section -->
                               <div class="main1">
                                    <!--bvn step one -->
                                    <div v-show="step === 2" class="text-center animated fadeIn">
                                        <div class="back-icon">
                                            <div class="back-icon" @click="prevStep">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                    </div>
                                        <h6 class="header__bvn--text">Add your BVN</h6>
                                        <p class="bvn--subtext">Your BVN helps us verify and confirm who you are.</p>
                                        <div class="bvn-form mt-4 text-center">
                                            <input type="text" pattern="\d*" maxlength="11" v-model="getBvn.bvn" placeholder="Your BVN" required>
                                            <!-- <p class="mt-2">I don't know my BVN</p> -->
                                            <button class="proceed-btn mt-4" @click="validateBvn" :disabled="loading === true" :class="{'submit__btn': loading}" type="button">
                                                <div v-if="loading" class='loader-box'>
                                                    <div class='loader-15'></div>
                                                </div>
                                                <div v-else>Proceed</div>
                                            </button>
                                        </div>
                                        <div class="login--section">
                                            <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                        </div>
                                    </div>
                                    <!-- bvn step 3 confirm BVN -->
                                    <div v-show="step === 3" class="text-center animated fadeIn">
                                        <div class="back-icon" @click="prevStep">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                        <h6 class="header__bvn--text">Confirm your BVN</h6>
                                        <!--<p class="bvn--subtext">An SMS with the One Time Password(OTP) has been sent to your registered mobile number.</p>
                                        --><p class="bvn--subtext">A code will be sent to the phone number linked to your BVN. If you don't have access to the phone number skip this step.</p>
                                        <div class="text-center mt-3">
                                            <p class="bvn--subtext">Enter the 6 digit code sent to {{maskedPhoneNumber}}</p>
                                            <div class="bvn-form mt-3">
                                                <v-otp-input
                                                    style="justify-content: center"
                                                    ref="otpInput"
                                                    input-type="password"
                                                    input-classes="otp-input"
                                                    separator=""
                                                    :num-inputs="6"
                                                    :should-auto-focus="true"
                                                    :is-input-num="true"
                                                    @on-complete="handleOnComplete"
                                                />
                                                <p class="mt-2 text-center">{{countDown}}</p>
                                                <button class="proceed-btn mt-4" @click="validateBvnOtp" :disabled="loading === true" :class="{'submit__btn': loading}" type="button">
                                                    <div v-if="loading" class='loader-box'>
                                                        <div class='loader-15'></div>
                                                    </div>
                                                    <div v-else>Confirm</div>
                                                </button>
                                                <div class="text-center">
                                                    <button type="button" class="request-otp" @click="requestNewOtp">Request New OTP</button>
                                                </div>
                                            </div>
                                            <p style="font-size: 14px; letter-spacing: 0;">You can also:</p>
                                            <p class="alt-means text-center" @click="goToStep('verify')">Verify with alternative means</p> 
                                            <hr>
                                            <div class="login--section">
                                                <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- bvn step 4 user details-->
                                    <div v-show="step === 4" class="animated fadeIn">
                                        <div class="back-icon" @click="prevStep">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                        <h6 class="header__bvn--text text-center">Start</h6>
                                        <p class="bvn--subtext text-center">Open an account with TAJBank step by step..</p>
                                        <p class="bvn--subtext text-center">Fill in the correct details in the form provided.</p>
                                        <div class="bvn-form mt-3">
                                            <div style="padding: 0px 1px">
                                                <div class="form--input">
                                                    <select class="form--input" v-model="form.title" placeholder="Select Title">
                                                        <option value="">Select Title</option>
                                                        <option value="Mr">Mr</option>
                                                        <option value="Miss">Miss</option>
                                                        <option value="Mrs">Mrs</option>
                                                    </select>
                                                    <!-- <input type="text" v-model="form.title" placeholder="Title" required> -->
                                                </div>
                                                <div class="form--input">
                                                    <input type="text" v-model="form.firstName" readonly placeholder="Surname / First Name" required>
                                                    <p v-if="submitted && !$v.form.firstName.required" class="error__text">First Name is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="text" v-model="form.lastName" readonly placeholder="Last Name" required>
                                                    <p v-if="submitted && !$v.form.lastName.required" class="error__text">Last Name is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="text" v-model="form.middleName" readonly placeholder="Middle Name">
                                                </div>
                                                <div class="form--input mb-3">
                                                    <select class="form-control" placeholder="Select Gender" v-model="form.gender" id="gender" name="gender">
                                                        <option value="" disabled>Select Gender</option>
                                                        <option v-for="gen in gender" :value="gen.id" :key="gen.id">{{gen.name}}</option>
                                                    </select>
                                                    <p v-if="submitted && !$v.form.gender.required" class="error__text">Gender is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="email" v-model="form.email" placeholder="Email" required>
                                                    <p v-if="submitted && !$v.form.email.required" class="error__text">Email is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="text" v-model="form.phoneNumber" readonly placeholder="Phone Number" required>
                                                    <p v-if="submitted && !$v.form.phoneNumber.required" class="error__text">Phone Number is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="date" v-model="form.dateOfBirth" readonly placeholder="Date of Birth" required>
                                                    <p v-if="submitted && !$v.form.dateOfBirth.required" class="error__text">Date of Birth is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="text" v-model="form.addressLine1" placeholder="Address" required maxlength="60">
                                                    <p v-if="submitted && !$v.form.addressLine1.required" class="error__text">Address is required</p>
                                                </div>
                                                <div class="form--input mb-3">
                                                    <select class="form-control" @change="getLGA" placeholder="State of Residence" v-model="form.state">
                                                        <option value="" disabled>State of Residence</option>
                                                        <option v-for="state in states" :value="state.id" :key="state.id">{{state.name}}</option>
                                                    </select>
                                                    <p v-if="submitted && !$v.form.state.required" class="error__text">State is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="text" v-model="form.city" placeholder="City" required>
                                                </div>
                                                <div class="form--input mb-3">
                                                    <select class="form-control" @change="getLocal" placeholder="LGA" v-model="form.lgaId">
                                                        <option value="" disabled>LGA</option>
                                                        <option v-for="lg in lga" :value="lg.id" :key="lg.id">{{lg.name}}</option>
                                                    </select>
                                                    <p v-if="submitted && !$v.form.lgaId.required" class="error__text">LGA is required</p>
                                                </div>
                                                <div class="form--input mb-3">
                                                    <select class="form-control" placeholder="Select Account Type" v-model="form.schemeClass">
                                                        <option value="" disabled>Select Account Type</option>
                                                        <option :value="1">Profit Bearing</option>
                                                        <option :value="2">Non-Profit Bearing</option>
                                                    </select>
                                                    <p v-if="submitted && !$v.form.schemeClass.required" class="error__text">Account type is required</p>
                                                </div>
                                                <div class="form--input">
                                                    <input type="number" v-model="form.nationalIdentificationNumber" maxlength="16" placeholder="NIN ( Optional )">
                                                    <p v-if="submitted && !$v.form.nationalIdentificationNumber.maxLength" class="error__text">NIN must be 16 Numbers</p>
                                                </div>
                                                <div class="form--input">
                                                  <input type="text" v-model="form.referralCode" placeholder="Referral code ( Optional )">
                                                </div>
                                            </div>
                                            <div class="text-center">
                                                <button type="button" @click="validateform" class="proceed-btn mt-3">Next</button>
                                            </div>
                                            <hr>
                                            <div class="login--section">
                                                <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- bvn step alternative means -->
                                    <div v-show="step === 'verify'" class="animated fadeIn">
                                        <div class="back-icon" @click="goBackToStep(3)">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                        <h6 class="header__bvn--text">Confirm your BVN</h6>
                                        <p class="bvn--subtext">Verify your BVN with your registered details.</p>
                                        <p class="bvn--subtext">Fill in the correct details in the form provided.</p>
                                        <div class="bvn-form mt-3">
                                            <div style="padding: 0px 1px">
                                                <div class="form--input">
                                                    <input type="text" v-model="bvnDetails.lastName" placeholder="Surname / Last Name" required>
                                                </div>
                                                <div class="form--input mt-2">
                                                    <input type="text" v-model="bvnDetails.firstName" placeholder="First Name" required>
                                                </div>
                                                <div class="form--input text-center mt-2">
                                                    <input type="date" v-model="bvnDetails.dateOfBirth" placeholder="Date of Birth">
                                                </div>
                                                <div class="text-center">
                                                    <button class="proceed-btn mt-4" @click="validateBvnDetails" :disabled="loading === true" :class="{'submit__btn': loading}" type="button">
                                                        <div v-if="loading" class='loader-box'>
                                                            <div class='loader-15'></div>
                                                        </div>
                                                        <div v-else>Confirm</div>
                                                    </button>
                                                </div>
                                            </div> 
                                            <div class="login--section">
                                                <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                            </div> 
                                        </div>
                                    </div>
                                    <!-- step 5 set password -->
                                    <div v-show="step === 5" class="animated fadeIn">
                                        <div class="back-icon" @click="goBackToStep(4)">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                        <h6 class="header__bvn--text">Set your password</h6>
                                        <p class="bvn--subtext">Set your password for your account.</p>
                                        <div class="bvn-form mt-4">
                                            <div style="padding: 0px 1px">
                                                <div class="form--input">
                                                    <input :type="type" v-model="form.password" placeholder="Enter Password">
                                                    <img src="../assets/TAJimages/SVG/eye-1.svg" @click="showPassword" alt="" class="icon-eye">
                                                </div>
                                                <div class="form--input mt-2">
                                                    <input :type="type_" v-model="form.confirmPassword" placeholder="Re-enter Password">
                                                    <img src="@/assets/TAJimages/SVG/eye-1.svg"  @click="_showPassword" alt="" class="icon-eye">
                                                </div>
                                                <div class="form--input text-center mt-3">
                                                    <button type="button" @click="validatePassWord" class="proceed-btn mt-3">Submit</button>
                                                </div>
                                            </div>
                                            <div class="login--section">
                                                <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- step 6 security question -->
                                    <div v-show="step === 6" class="animated fadeIn">
                                        <div class="back-icon" @click="prevStep">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                        <h6 class="header__bvn--text mt-3">Set your security question</h6>
                                        <p class="bvn--subtext">Set your security question for your account.</p>
                                        <div class="security-question mt-3">
                                          <form @submit.prevent="proceedForSecurity">
                                            <div class="form--input mt-2 mb-2" v-for="(secQuestion, ix) in securityDetails" :key="ix">
                                              <p class="mb-0 q-header">Question {{ix+1}}</p>
                                                  <select class="form-control" @change="setSecurityQuestion($event, ix)" placeholder="Select" v-model="secQuestion.id" required>
                                                      <option :value="secQuestion.id" disabled>{{secQuestion.question ? secQuestion.question : 'Select Security Question'}}</option>
                                                      <option v-for="(question, index) in getNewSecurityQuestion" :value="question.id" :key="index">{{question.question}}</option>
                                                  </select>
                                                  <!--<v-select @input="setSecurityQuestion" v-model="question.id" label="question" :reduce="question => question.id" :options="securityQuestion" placeholder="Pick Your Question"></v-select>
                                                  --><p class="question--subtext mt-2 mb-1">Answer {{ ix+1 }}</p>
                                                  <input class="answer-input" v-model="secQuestion.response" :type="secQuestion.answerType" placeholder="Enter Your Answer" required>
                                                  <span @click="showAnswerPin(ix)" class="pull-right show-pin">{{secQuestion.answerType === 'password' ? 'show' : 'hide'}}</span>
                                              </div>
                                            <div class="form--input text-center mt-3">
                                                <button type="submit" class="proceed-btn mt-3">Next</button>
                                            </div>
                                          </form>
                                        </div>
                                    </div>
                                    <!--verification section -->
                                    <div v-show="step === 7" class="text-center animated fadeIn">
                                        <div class="back-icon" @click="prevStep">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                        <h6 class="header__bvn--text">Let us know you more</h6>
                                        <p class="bvn--subtext">Take a clear photo of yourself showing all important facial features. Also you can upload your signature.</p>
                                        <div class="text-center mt-3">
                                            <div class="bvn-form mt-3">
                                                <div class="d-flex justify-content-between flex-column p-4">
                                                    <face-verification/>
                                                    <div class="file-upload">
                                                        <p class="photo-text mt-5">Upload signature</p>
                                                        <label for="upload" class="file-upload__label"><i class='icon-file'></i></label>
                                                        <input
                                                            id="upload" 
                                                            class="file-upload__input"
                                                            ref="image"
                                                            type="file"
                                                            name="file-upload"
                                                            accept="image/*"
                                                            @change="setSignature"
                                                        />
                                                        <div class="mt-2 d-flex justify-content-center" v-if="uploadSucess">
                                                            <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                                            <p style="color: #4BB543;"> Signature uploaded successfully</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="text-center mt-5">
                                                  <p @click="step++" style="color: #E41613; cursor: pointer; font-size: 16px">Skip</p>
                                                </div> -->
                                                <button class="proceed-btn mt-3" @click="proceedForSignature" :disabled="loading" :class="{'submit__btn': loading}" type="button">
                                                    <div v-if="loading" class='loader-box'>
                                                        <div class='loader-15'></div>
                                                    </div>
                                                    <div v-else>Next</div>
                                                </button>
                                            </div>
                                            <hr>
                                            <div class="login--section">
                                                <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- upload documents -->
                                    <div v-show="step === 8" class="text-center animated fadeIn">
                                        <div class="back-icon" @click="prevStep">
                                            <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                        </div>
                                        <h6 class="header__bvn--text">Upload Photo</h6>
                                        <p class="bvn--subtext">Upload a clear photo of yourself.</p>
                                        <div class="text-center mt-3">
                                            <form enctype="multipart/form-data" @submit.prevent="signUpNewUserFunction">
                                                <div class="bvn-form mt-3">
                                                    <div class="d-flex flex-column justify-content-center p-4">
                                                        <!-- <div class="text-center">
                                                            <p class="text-center photo-text mt-2">Upload ID card (Optional)</p>
                                                                <select class="form-control mb-3" @change="seletctIdTypes" id="idType" name="idType">
                                                                    <option value="">Select ID type</option>
                                                                    <option v-for="id in idTypes" :value="id.id" :key="id.id">{{id.description}}</option>
                                                                </select>
                                                                <label for="upload-id" class="file-upload__label"><i class='icon-file'></i></label>
                                                                <input
                                                                    id="upload-id" 
                                                                    class="file-upload__input"
                                                                    type="file"
                                                                    name="id-upload"
                                                                    accept="image/*"
                                                                    @change="setIdCard"
                                                                />
                                                                <p v-if="IDMessage" style="color: #E41613;"> Uploading ID Please wait...</p>
                                                            <div class="mt-2 d-flex justify-content-center" v-if="idUploadSucces">
                                                                <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                                                <p style="color: #4BB543;"> ID uploaded successfully</p>
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-5">
                                                            <p class="text-center photo-text mt-2">Upload Utility Bill (Optional)</p>
                                                            <label for="bills-upload" class="file-upload__label"><i class='icon-file'></i></label>
                                                            <input
                                                                id="bills-upload" 
                                                                class="file-upload__input"
                                                                ref="image"
                                                                type="file"
                                                                name="file-upload"
                                                                accept="image/*"
                                                                @change="setUtilityBill"
                                                            />
                                                            <p v-if="utlityMessage" style="color: #E41613;"> Utility Bill uploading Please wait...</p>
                                                            <div class="mt-2 d-flex justify-content-center" v-if="utilityBillSuccess">
                                                                <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                                                <p style="color: #4BB543;"> Utility Bill uploaded successfully</p>
                                                            </div>
                                                        </div> -->
                                                        <div class="text-center">
                                                            <p class="text-center photo-text mt-2">Upload Photo</p>
                                                            <label for="photo-upload" class="file-upload__label"><i class='fa fa-user-circle-o text-danger' style="font-size: 21px"></i></label>
                                                            <input
                                                                id="photo-upload" 
                                                                class="file-upload__input"
                                                                ref="image"
                                                                type="file"
                                                                name="photo-upload"
                                                                accept="image/*"
                                                                @change="setUserPhoto"
                                                            />
                                                            <div class="mt-2 d-flex justify-content-center" v-if="photoSuccess">
                                                                <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                                                <p style="color: #4BB543;"> Photo uploaded successfully</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-4">
                                                      <input style="background-color: red; height: 15px; width: 15px;" type="checkbox" name="checkbox" class="mb-0 mr-2" value="check" v-model="checked"/>
                                                      <p class="mb-0"> I have read and agree to the <a href="https://digitaltest.tajbank.com/files/Account_Opening_T&C.pdf" target="_blank" class="primary-color">Terms and Conditions</a></p>
                                                    </div>
                                                    <button class="proceed-btn mt-3" :disabled="loading" :class="{'submit__btn': loading}" type="submit" style="width:255px !important; heigth: 50px !important ">
                                                        <div v-if="loading">
                                                            <div class="text-dark font-weight-bold">{{loaderText}}</div>
                                                        </div>
                                                        <div v-else>Complete</div>
                                                    </button>
                                                </div>
                                            </form>
                                            <hr>
                                            <div class="login--section">
                                                <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- sign up existing user -->
                                    <section>
                                        <div class="main1">
                                        <div  v-show="step === 9">
                                            <div  class="text-center animated fadeIn">
                                                <div class="back-icon" @click="goToStep(1)">
                                                    <div class="back-icon">
                                                    <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                                </div>
                                            </div>
                                                <h6 class="header__bvn--text">Input your account number</h6>
                                                <p class="bvn--subtext">Input your account number in the field below.</p>
                                                <div class="bvn-form mt-4 text-center">
                                                    <input type="text" pattern="\d*" @keypress="isNumber" v-model="existingUserDetails.accountNumber" maxlength="10" placeholder="Account Number" required>
                                                    <!-- <p class="mt-2">I don't know my BVN</p> -->
                                                    <button class="proceed-btn mt-4" @click="verifyAccountNumber" :disabled="loading === true" :class="{'submit__btn': loading}" type="button">
                                                        <div v-if="loading" class='loader-box'>
                                                            <div class='loader-15'></div>
                                                        </div>
                                                        <div v-else>Next</div>
                                                    </button>
                                                </div>
                                                <div class="login--section">
                                                    <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                                </div>
                                            </div>
                                            </div>
                                            <!-- validate OTP -->
                                            <div class="text-center animated fadeIn"  v-show="step === 10">
                                                <div class="back-icon" @click="prevStep">
                                                    <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                                </div>
                                                <h6 class="header__bvn--text">Confirm your account</h6>
                                                <!--<p class="bvn--subtext">An SMS with the One Time Password(OTP) has been sent to your registered mobile number.</p>
                                                --><p class="bvn--subtext">An SMS with the One Time Password(OTP) has been sent to your registered mobile number.</p>
                                                <div class="text-center mt-3">
                                                    <p class="bvn--subtext">Enter the 6 digit code sent to {{maskedPhoneNumber}} </p>
                                                    <div class="bvn-form mt-3">
                                                        <v-otp-input
                                                            style="justify-content: center"
                                                            ref="otpInput2"
                                                            input-type="password"
                                                            input-classes="otp-input"
                                                            separator=""
                                                            :num-inputs="6"
                                                            :should-auto-focus="true"
                                                            :is-input-num="true"
                                                            @on-complete="handleOnComplete"
                                                        />
                                                        <p class="mt-2 text-center">{{countDown}}</p>
                                                        <button class="proceed-btn mt-4" :class="{'submit__btn': loading}" @click="validateExistingUserToken" type="button">
                                                            <div v-if="loading" class='loader-box'>
                                                                <div class='loader-15'></div>
                                                            </div>
                                                            <div v-else>Confirm</div>
                                                        </button>
                                                        <div class="text-center">
                                                            <button type="button" class="request-otp" @click="requestNewOtp">Request New OTP</button>
                                                        </div>
                                                    </div>
                                                    <div class="login--section">
                                                        <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--verification section -->
                                            <div class="text-center animated fadeIn"  v-show="step === 11">
                                                <div class="back-icon" @click="prevStep">
                                                    <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                                </div>
                                                <h6 class="header__bvn--text">Take a picture of yourself</h6>
                                                <p class="bvn--subtext">Take a clear photo of yourself showing all important facial features.</p>
                                                <div class="text-center mt-3">
                                                    <div class="bvn-form mt-3">
                                                        <div class="d-flex justify-content-between flex-column p-4">
                                                            <face-verification/>
                                                        </div>
                                                        <!-- <div class="text-center mt-5">
                                                            <p @click="goToStep(12)" style="color: #E41613; cursor: pointer; font-size: 16px">Skip</p>
                                                        </div> -->
                                                        <button class="proceed-btn mt-3" @click="proceedForSignature" :disabled="loading" :class="{'submit__btn': loading}"  type="button">
                                                            <div v-if="loading" class='loader-box'>
                                                                <div class='loader-15'></div>
                                                            </div>
                                                            <div v-else>Next</div>
                                                        </button>
                                                    </div>
                                                    <div class="login--section">
                                                        <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- step set password -->
                                            <div class="animated fadeIn"  v-show="step === 12">
                                                <div class="back-icon" @click="goToStep(11)">
                                                    <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                                </div>
                                                <h6 class="header__bvn--text">Set your password</h6>
                                                <p class="bvn--subtext">Set your password for your account.</p>
                                                <div class="bvn-form mt-4">
                                                    <div style="padding: 0px 1px">
                                                        <div class="form--input">
                                                            <input :type="type" v-model="form.password" placeholder="Enter Password">
                                                            <img src="../assets/TAJimages/SVG/eye-1.svg" @click="showPassword" alt="" class="icon-eye">
                                                        </div>
                                                        <div class="form--input mt-2">
                                                            <input :type="type_" placeholder="Re-enter Password" v-model="form.confirmPassword">
                                                            <img src="@/assets/TAJimages/SVG/eye-1.svg" alt="" @click="_showPassword" class="icon-eye">
                                                        </div>
                                                        <div class="form--input text-center mt-3">
                                                            <button type="button" @click="validatePassWord" class="proceed-btn mt-3">Next</button>
                                                        </div>
                                                    </div>
                                                    <div class="login--section">
                                                        <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- step security question -->
                                            <div  class="animated fadeIn"  v-show="step === 13">
                                                <div class="back-icon" @click="goToStep(12)">
                                                    <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                                </div>
                                                <h6 class="header__bvn--text mt-3">Set your security question</h6>
                                                <p class="bvn--subtext">Set your security question for your account.</p>
                                                <div class="security-question mt-3">
                                                  <form @submit.prevent="signupExistingUser">
                                                    <div class="form--input mt-2 mb-2" v-for="(secQuestion, key) in securityDetails" :key="key">
                                                        <p class="mb-0 q-header">Question {{key+1}}</p>
                                                        <select class="form-control" @change="setSecurityQuestion($event, key)" placeholder="Select" v-model="secQuestion.id" required>
                                                            <option :value="secQuestion.id" disabled>{{secQuestion.question ? secQuestion.question : 'Select Security Question'}}</option>
                                                            <option v-for="(question, index) in getNewSecurityQuestion" :value="question.id" :key="index">{{question.question}}</option>
                                                        </select>
                                                        <!--<v-select @input="setSecurityQuestion" v-model="question.id" label="question" :reduce="question => question.id" :options="securityQuestion" placeholder="Pick Your Question"></v-select>
                                                        --><p class="question--subtext mt-2 mb-1">Answer {{ key+1 }}</p>
                                                        <input class="answer-input" v-model="secQuestion.response" :type="secQuestion.answerType" placeholder="Enter Your Answer" required>
                                                        <span @click="showAnswerPin(key)" class="pull-right show-pin">{{secQuestion.answerType === 'password' ? 'show' : 'hide'}}</span>
                                                    </div>
                                                    <div class="form--input text-center mt-3">
                                                        <button class="proceed-btn mt-3" :class="{'submit__btn': loading}" type="submit" style="width:255px !important; heigth: 50px !important" >
                                                            <div v-if="loading">
                                                                <div class="text-dark font-weight-bold">{{loaderText}}</div>
                                                            </div>
                                                            <div v-else>Next</div>
                                                        </button>
                                                    </div>
                                                  </form>
                                                <div class="login--section">
                                                    <p class="text-center">Have a profile? <span @click="goBackToStep(1)" class="account-btn">Log in</span></p>
                                                </div>
                                                </div>
                                            </div>
                                            <!-- welcome message -->
                                            <div class="animated fadeIn text-center welcome-wrapper" v-show="step === 14">
                                              <h3 class="welcome-text">Welcome to TAJBank</h3>
                                              <p class="welcome-subtext">Your account has been created</p>
                                              <div class="mt-3">
                                                <p class="accounts-details-title">Your Account Name</p>
                                                <h3 class="accounts-details-subtitle" ref="accountName"></h3>
                                                <p class="accounts-details-title">Your Account Type</p>
                                                <h3 class="accounts-details-subtitle" ref="accountType"></h3>
                                                <p>Your Account Number</p>
                                                <h4 class="accounts-details-subtitle" ref="accountNumber"></h4>
                                              </div>
                                              <div class="login--section mt-5" @click="setLoginPage" style="cursor:cursor">
                                                <p style="border-radius:10px" class="text-center text-white bg-danger py-2"><span>Log in</span></p>
                                              </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- Plugin used-->
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  const { required, maxLength } = require('vuelidate/lib/validators');
  import moment from 'moment';
  import faceVerification from '../components/face-verification.vue';
  import { decrypt } from '@/_services/encryption';
  //   import $ from 'jquery';
  export default {
    name: 'login',
    components: {
      faceVerification
    },
    data:() => ({
      loginForm: {
        username: null,
        password: null,
        appVersion: '0',
        platform: 1,
        customerType: 2,
      },
      form: {
        documents: [],
        title: '',
        firstName: null,
        lastName: null,
        middleName: null,
        email: null,
        phoneNumber: null,
        gender: '',
        state: '',
        dateOfBirth: moment().format('L'),
        addressLine1: null,
        city: null,
        lgaId: '',
        bankVerificationNumber: null,
        nationalIdentificationNumber: null,
        password: null,
        confirmPassword: null,
        photo: '',
        referralCode: '',
        platform: 1,
        signature: null,
        securityDetails: [],
        idTypes: null,
        schemeClass: ''
      },
      securityDetails: [
        { id: '', question: '', response: null, answerType: 'password', },
        { id: '', question: '', response: null, answerType: 'password', },
        { id: '', question: '', response: null, answerType: 'password', },
      ],
      documents: [ 
        { verificationId: null, fileName: null, document: null, documentType: null },
        { verificationId: null, fileName: null, document: null, documentType: null },
      ],
      bvnDetails: {
        firstName: null,
        lastName: null,
        dateOfBirth: null,
        platform: 1,
      },
      getBvn: {
        bvn: null,
        platform: 1,
      },
      otp: null,
      type: 'password',
      loading: false,
      step: 1,
      uploadSucess: false,
      idUploadSucces: false,
      utilityBillSuccess: false,
      submitted: false,
      type_: 'password',
      answerType: 'password',
      newSecurityDetails: null,
      formData: null,
      maskedPhoneNumber: null,
      utlityMessage: false,
      IDMessage: false,
      existingUserDetails: {
        accountNumber: null,
        photo: null,
        securityDetails: [],
        platform: 1,
      },
      existingUserDetailsBVN: null,
      documentType: null,
      getNewSecurityQuestion: null,
      loaderText: 'Please wait...',
      countDown: null,
      photoSuccess: false,
      checked: false,
      selectedQuestion: null,
      prevSelectedQuestions: [
        null, // initially, no question has been selected for index 0
        null, // initially, no question has been selected for index 1
        null, // initially, no question has been selected for index 2
      ],
    }),
    validations: {
      form: {
        firstName: { required },
        lastName: { required },
        email: { required },
        dateOfBirth: { required },
        phoneNumber: { required },
        gender: { required },
        addressLine1: { required },
        state: { required },
        lgaId: { required },
        nationalIdentificationNumber: { maxLength: maxLength(16) },
        schemeClass: { required }
      },
    },
    computed: {
      // get security question from store
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        securityQuestion: state => state.authentication ? state.authentication.securityQuestion : null,
        // eslint-disable-next-line no-confusing-arrow
        states: state => state.authentication ? state.authentication.states : null,
        // eslint-disable-next-line no-confusing-arrow
        gender: state => state.authentication ? state.authentication.gender : null,
        // eslint-disable-next-line no-confusing-arrow
        lga: state => state.authentication ? state.authentication.lga : null,
        // eslint-disable-next-line no-confusing-arrow
        idTypes: state => state.authentication ? state.authentication.idTypes : null,
        faceVerificationImage: state => state.authentication.image
      }),
    },
    async mounted() {
      await Promise.all([
        this.$store.dispatch('getGender'),
        this.$store.dispatch('getStates'),
        this.$store.dispatch('getIdTypes'),
        this.$store.dispatch('getSecurityQuestion'),
        this.$store.dispatch('getLga')
      ]);
      this.getNewSecurityQuestion = this.securityQuestion.map((item) => {
        return {
          id: item.id,
          question: item.question,
          response: ''
        };
      });
    },
    methods: {
      setLoginPage() {
        window.location.reload();
      },
      handleCountDown() {
        this.countDown = 60;
        let countDownInterval = setInterval(() => {
          if(this.countDown > 0) {
            this.countDown--;
          } else {
            clearInterval(countDownInterval);
          }
        }, 1000);
      },
      showAnswerPin(id) {
        this.securityDetails.forEach(item => {
          if (item.newId === id) {
            item.answerType = item.answerType === 'password' ? 'text' : 'password';
          }
        });
      },
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      setSignature(event) {
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result;
            this.form.signature = fileData;
            this.uploadSucess = true;
          };
          reader.readAsDataURL(input.files[0]);
        }
      },
      setUserPhoto(event) {
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result;
            this.form.photo = fileData;
            this.photoSuccess = true;
          };
          reader.readAsDataURL(input.files[0]);
        }
      },
      seletctIdTypes(event) {
        this.documentType = event.target.value;
      },
      // set id card
      setIdCard(event) {
        this.idUploadSucces = false;
        this.clearObject(this.form.documents, 'documentType', this.documentType);
        if (this.documentType === null) {
          this.$toasted.show('Please select ID type', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
        }else {
          const input = event.target;
          if (input.files) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
              this.documents[0].document = fileData;
            };
            reader.readAsDataURL(input.files[0]);
          }
          const fileName = event.target.files[0].name;
          this.idUploadSucces = true;
          this.documentType = parseInt(this.documentType);
          setTimeout(() => {
            this.form.documents.push({ documentType: this.documentType, fileName, document: this.documents[0].document });
          }, 200);
        }
      },
      getAsByteArray(file) {
        return new Uint8Array(this.readFile(file));
      },
      readFile(file) {
        let reader = new FileReader();
        reader.onload = function(e) {
          const data = e.target.result;
          console.log(data, 'from onload');
        };
        reader.readAsArrayBuffer(file);
      },
      setUtilityBill(event) {
        this.utilityBillSuccess = false;
        this.clearObject(this.form.documents, 'documentType', 5);
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
            this.documents[1].document = fileData;
          };
          reader.readAsDataURL(input.files[0]);
        }
        const fileName = event.target.files[0].name;
        const documentType = 5;
        this.utilityBillSuccess = true;
        setTimeout(() => {
          this.form.documents.push({ documentType, fileName, document: this.documents[1].document });
        }, 200);
      },
      getLocal(event) {
        this.form.lgaId = event.target.value;
      },
      async getLGA() {
        await this.$store.dispatch('getLga', this.form.state);
      },
      // show/hide password
      showPassword() {
        this.type = this.type === 'text' ? 'password' : 'text';
      },
      _showPassword() {
        this.type_ = this.type_ === 'text' ? 'password' : 'text';
      },
      handleOnComplete(value) {
        this.otp = value;
      },
      handleClearInput() {
        this.$refs.otpInput.clearInput();
      },
      handleClearInput2() {
        this.$refs.otpInput2.clearInput();
      },
      nextStep () {
        // this.form.securityDetails = [...this.securityDetails];
        this.step++;
      },
      proceedForSecurity() {
        this.form.securityDetails = this.securityDetails.map((sec) => {
          return {
            id: sec.id,
            response: sec.response
          };
        });
        this.step++;
      },
      // convert dataURI to blob
      dataURItoBlob(dataURI) {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      },
      // convert dataURI to file
      dataURItoFile(dataURI, filename) {
        const blob = this.dataURItoBlob(dataURI);
        const file = new File([blob], filename, { type: 'image/png' });
        return file;
      },
      proceedForSignature() {
        if (this.step === 7 && this.form.signature === null) {
          this.$toasted.show('Kindly upload your signature', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
          return false;
        }
        if(this.faceVerificationImage){
          this.step++;
        } else {
          this.step++;
        } 
      },
      verifyPhoto() {
        if(this.faceVerificationImage === null) {
          this.$toasted.show('Please Take a Photo', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
          return;
        } else {
          var blob = this.dataURItoFile(this.faceVerificationImage, 'live-photo.png');
          const formData = new FormData();
          const checkBvn = this.step === 11 ? this.existingUserDetailsBVN : this.getBvn.bvn;
          formData.append('bvn', checkBvn);
          formData.append('file', blob);
          formData.append('deviceId', 1);
          formData.append('platform', 1);
          this.loading = true;
          this.$store.dispatch('verifyFace', formData).then(response => {
            if(response.status === 200) {
              this.loading = false;
              this.step++;
            }
          }).catch(error => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.loading = false;
            this.$toasted.show(objError.errors[0], {
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 10000 
            });
          });
        }
      },
      validateform() {
        this.submitted = true;
        const invalid = this.$v.form.$invalid;
        if (!invalid) {
          this.nextStep();
        }
      },
      setSecurityQuestion(event, index) {
        // Get the new selected question ID
        const newQuestionId = event.target.value;
        // Find the new selected question object from the `questions` array
        const newQuestion = this.getNewSecurityQuestion.find(q => q.id === newQuestionId);
        // Get the previously selected question for this security question
        const prevQuestion = this.prevSelectedQuestions[index];
        // If there was a previously selected question, add it back to the `questions` array if it's different from the new question
        if (prevQuestion && prevQuestion.id !== newQuestionId) {
          this.getNewSecurityQuestion.push(prevQuestion);
        }
        // Remove the new selected question from the `questions` array
        this.getNewSecurityQuestion.splice(this.getNewSecurityQuestion.indexOf(newQuestion), 1);
        // Update the selected question object in the `securityDetails` array
        this.$set(this.securityDetails, index, {
          id: newQuestionId,
          question: newQuestion.question,
          response: this.securityDetails[index].response,
          answerType: 'password'
        });
        // Update the previously selected question for this security question
        this.prevSelectedQuestions[index] = {
          id: newQuestionId,
          question: newQuestion.question
        };
      },
      clearObject(array, key, value) {
        array.forEach((item, index) => {
          if (item[key] === value) {
            array.splice(index, 1);
          }
        });
      },
      // login user function
      async login() {
        try {
          this.loading = true;
          await this.$store.dispatch('login', this.loginForm);
          this.loading = false;
        } catch (error) {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.loading = false;
          this.$toasted.show(objError.errors[0], {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 10000 
          });
        }
      },
      async requestNewOtp() {
        const data = {
          phoneNumber: this.form.phoneNumber,
          platform: 1
        };
        try {
          await this.$store.dispatch('generateSignUpToken', data).then(response => {
            if(response.status === 200) {
              this.$toasted.show('OTP has been sent to your phone Number', { 
                theme: 'outline',
                position: 'top-right',
                icon : 'check', 
                type: 'success', 
                duration: 10000 
              });
            }
          });
        } catch (error) {
          const decryptedError = decrypt(error.response.data.errors);
          const objError = JSON.parse(decryptedError);
          objError.forEach((error) => {
            this.$toasted.show(error, { 
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 10000 
            });
          });
        }
      },
      // function to generate OTP for new user
      async generateSignUpOtp() {
        this.loading = true;
        const data = {
          phoneNumber: this.form.phoneNumber,
          platform: 1
        };
        try {
          await this.$store.dispatch('generateSignUpToken', data).then(response => {
            if(response.status === 200) {
              this.step++;
            }
          });
          this.loading = false;
        } catch (error) {
          this.loading = false;
          const decryptedError = decrypt(error.response.data.errors);
          const objError = JSON.parse(decryptedError);
          objError.forEach((error) => {
            this.$toasted.show(error, { 
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 10000 
            });
          });
        }
      },
      // validate sign up token for new user
      async validateBvnOtp() {
        const data = {
          phoneNumber: this.form.phoneNumber,
          token: this.otp,
          platform: 1,
        };
        try {
          this.loading = true;
          await this.$store.dispatch('validateBvnOtp', data);
          this.loading = false;
          this.nextStep();
        } catch (error) {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$toasted.show(objError.errors[0], {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 10000 
          });
        }
      },
      validatePassWord(){
        // password must include at least one number, one lowercase and one uppercase letter
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (this.form.password !== this.form.confirmPassword) {
          this.$toasted.show('Password does not match', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
        } else if (!passwordRegex.test(this.form.password)) {
          // password must be at least 8 characters long and contain at least one number, one lowercase and one uppercase letter
          this.$toasted.show('Password must be at least 8 characters long and contain at least one number, one lowercase and one uppercase letter', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
        } else {
          this.nextStep();
        }
      },
      // validate bvn function
      async validateBvn() {
        // check if bvn feild is empty and less than 11 characters
        if (this.getBvn.bvn === null || this.getBvn.bvn.length < 11) {
          this.$toasted.show('Please enter a valid BVN number', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 5000 
          });
        } else {
          try {
            this.loading = true;
            const response = await this.$store.dispatch('validateBvn', this.getBvn);
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (userParseData.responseCode !== '00') {
              this.loading = false;
              this.$toasted.show(userParseData.responseDescription, { 
                theme: 'outline',
                position: 'top-right',
                icon : 'times', 
                type: 'error', 
                duration: 4000 
              });
            } else {
              const  data  = userParseData;
              let phoneNumber = userParseData.phoneNumber;
              this.maskedPhoneNumber = phoneNumber.substring(7, 7) + '*******' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length);
              this.form.firstName = data.firstname,
              this.form.lastName = data.lastname,
              this.form.middleName = data.middlename,
              this.form.email = data.email,
              this.form.phoneNumber = data.phoneNumber,
              this.form.dateOfBirth = moment(data.dateOfBirth).format('YYYY-MM-DD'),
              this.form.bankVerificationNumber = data.bvn,
              this.form.nationalIdentificationNumber = data.nationalId,
              this.loading = false;
              this.generateSignUpOtp();
            }
          } catch (error) {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$toasted.show(objError.errors[0], {
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 10000 
            });
          }
        }
      },
      
      // validate bvn details function
      async validateBvnDetails() {
        const data = {
          firstName: this.bvnDetails.firstName,
          lastName: this.bvnDetails.lastName,
          dateOfBirth: this.bvnDetails.dateOfBirth,
          platform: 1,
          bvn: this.getBvn.bvn,
        };
        // check if fields are empty
        if (data.firstName === null || data.lastName === null || data.dateOfBirth === null) {
          this.$toasted.show('Please fill all the fields', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
        } else {
          try {
            this.loading = true;
            await this.$store.dispatch('validateBvnDetails', data);
            this.loading = false;
            this.goToStep(4);
          } catch (error) {
            this.loading = false;
            const decryptedError = decrypt(error.response.data.errors);
            const objError = JSON.parse(decryptedError);
            objError.forEach((error) => {
              this.$toasted.show(error, { 
                theme: 'outline',
                position: 'top-right',
                icon : 'times', 
                type: 'error', 
                duration: 10000 
              });
            });
          }
        }
        
      },
      // sign up new user function
      signUpNewUserFunction() {
        if (this.form.photo === '') {
          this.$toasted.show('Kindly Upload your photo', {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 6000 
          });
          return false;
        }
        if (!this.checked) {
          this.$toasted.show('Kindly accept terms and conditions', {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 6000 
          });
          return false;
        }
        const userData  = {
          ...this.form,
          platform: 1,
          requestId: 'test',
        };
        this.loading = true;
        setInterval(() => {
          var randomStrings = ['Creating account...', 'Mapping profile to account...','Completing profile...'];
          const randomIndex = Math.ceil((Math.random() * randomStrings.length - 1));
          const newText = randomStrings[randomIndex];
          this.loaderText = newText;
        }, 10000);
        this.$store.dispatch('signUpNewUser', userData).then((response) => {
          if(response.status === 200) {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            this.loading = false;
            this.$refs.accountName.innerHTML = userParseData.dashboardDetails.accounts[0].accountName;
            this.$refs.accountNumber.innerHTML = userParseData.dashboardDetails.accounts[0].accountNumber;
            this.$refs.accountType.innerHTML = userParseData.dashboardDetails.accounts[0].productName;
            this.goToStep(14);
            this.step = 14;
          }
        }).catch(error => {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$toasted.show(objError.errors[0], {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 10000 
          });
        });
      },
      // validate token for existing user 
      async validateExistingUserToken() {
        const data = {
          phoneNumber: this.form.phoneNumber,
          token: this.otp,
          platform: 1,
        };
        try {
          this.loading = true;
          await this.$store.dispatch('validateBvnOtp', data);
          this.loading = false;
          this.nextStep();
        } catch (error) {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$toasted.show(objError.errors[0], {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 10000 
          });
        }
      },
      // sign up existing user
      verifyAccountNumber() {
        // check if field is empty
        if (this.existingUserDetails.accountNumber === null || this.existingUserDetails.accountNumber.length < 10) {
          this.$toasted.show('Please enter a valid account number', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
        } else {
          this.loading = true;
          this.$store.dispatch('getUserAccount', this.existingUserDetails.accountNumber).then((response) => {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            this.loading = false;
            this.existingUserDetailsBVN = userParseData.bankVerificationNumber;
            this.form.phoneNumber = userParseData.phoneNumber;
            let phoneNumber = userParseData.phoneNumber;
            this.maskedPhoneNumber = phoneNumber.substring(7, 7) + '*******' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length);
            this.step++;
            // this.generateBVN();
          }).catch(error => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$toasted.show(objError.errors[0], {
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 10000 
            });
          });
        }
      },
      async generateBVN() {
        this.loading = true;
        const data = {
          bvn: this.existingUserDetailsBVN,
          generateOTP: true,
          platform: 1,
        };
        try {
          const response = await this.$store.dispatch('validateBvn', data);
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          this.form.phoneNumber = userParseData.phoneNumber;
          let phoneNumber = userParseData.phoneNumber;
          this.maskedPhoneNumber = phoneNumber.substring(7, 7) + '*******' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length);
          this.loading = false;
          if (userParseData.responseCode !== '00') {
            this.loading = false;
            this.$toasted.show(userParseData.responseDescription, { 
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 4000 
            });
          } else {
            this.step++;
            this.loading = false;
          }
        } catch(error) {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$toasted.show(objError.errors[0], {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 10000 
          });
        }
      },
      // sign up existing user function
      async signupExistingUser() {
        this.existingUserDetails.securityDetails  = this.securityDetails.map((sec) => {
          return {
            id: sec.id,
            response: sec.response
          };
        });
        const userData  = {
          ...this.existingUserDetails,
          password: this.form.password,
          confirmPassword: this.form.confirmPassword,
          platform: 1,
          requestId: 'test',
        };
        this.loading = true;
        setInterval(() => {
          var randomStrings = ['Creating profile...', 'Mapping profile to account...','Completing profile...'];
          const randomIndex = Math.ceil((Math.random() * randomStrings.length - 1));
          const newText = randomStrings[randomIndex];
          this.loaderText = newText;
        }, 10000);
        await this.$store.dispatch('signUpExistingUser', userData).then((response) => {
          if(response.status === 200) {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            this.loading = false;
            this.$refs.accountName.innerHTML = userParseData.dashboardDetails.accounts[0].accountName;
            this.$refs.accountNumber.innerHTML = userParseData.dashboardDetails.accounts[0].accountNumber;
            this.$refs.accountType.innerHTML = userParseData.dashboardDetails.accounts[0].productName;
            this.goToStep(14);
            this.step = 14;
          }
          // this.$toasted.show('Account created successfully', { 
          //   theme: 'outline',
          //   position: 'top-right',
          //   icon : 'check', 
          //   type: 'success', 
          //   duration: 4000 
          // });
        }).catch(error => {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$toasted.show(objError.errors[0], {
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 10000 
          });
        });
      },
      prevStep () {
        this.handleClearInput();
        this.handleClearInput2();
        this.step--;
      },
      goToStep (step) {
        this.step = step;
      },
      goBackToStep (step) {
        this.step = step;
      },
    },
  };
</script>
<style scoped>
* {
    letter-spacing: 0px !important;
}
.nifi-logo {
  position: relative;
  left: 60px;
  width: 150px
}
.submit__btn {
    background-color: #E6E6E6 !important;
}
.button-section {
    margin: 40px 0px;
}
.signup-btn {
    background-color: #E41613;
    color: #fff;
    font-size: 17px;
    width: 220px; 
    height: 50px;
    text-align: center;
    padding: 13px 70px;
    border-radius: 10px;
    font-weight: 400;
    cursor: pointer;
}
.signup-btn:hover {
    color: #fff;
}
.openaccount-btn {
    background-color: rgba(255, 255, 255, 0.7) !important;
    color: #E41613;
    width: 220px;
    height: 50px;
    font-size: 17px;
    padding: 13px 30px;
    border-radius: 10px;
    text-align: center;
    font-weight: 400;
    margin-left: 8px;
    cursor: pointer;
}
@media (max-width: 768px) {
    .openaccount-btn {
        margin: 10px 0px 0px 0px;
    }
    .button-section  {
        justify-content: center;
    }
    .login__header--text,
    .login__header--subtext {
        text-align: center;
    }
}
.login__header--text {
  font-size: 40px;
  margin-bottom: 8px;
}
.login__header--subtext {
  font-size: 20px;
}
/* animation code */
@keyframes gradient {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

body {
    background-color: #fff;
    max-width: 100vw;
    font-family: 'inter';
    overflow: -moz-scrollbars-vertical;
    overflow-x: hidden;
    overflow-y: auto;
}

@keyframes cf3FadeInOut {
    0% {
        opacity: 1;
    }
    45% {
        opacity: 1;
    }
    55% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
}

@keyframes fade {
    0% {
        opacity: 0;
    }

    11.11% {
        opacity: 1;
    }

    33.33% {
        opacity: 1;
    }

    44.44% {
        opacity: 0;
    }

    100% {
        opacity: 0;
    }
}

#cf3 {
    position: fixed;
    height: 100%;
    width: 100%;
}

#cf3 img {
height: 100%;
width: 100%;
object-fit: cover;
-webkit-transition: opacity 1s ease-in-out;
-moz-transition: opacity 1s ease-in-out;
-o-transition: opacity 1s ease-in-out;
transition: opacity 1s ease-in-out;
position: absolute;
}

.fadein img {
    opacity: 0;
    animation-name: fade;
    animation-duration: 18s;
    animation-iteration-count: infinite;
    position: absolute;
    left: 0;
    right: 0;
}

#cf3 img:nth-child(1) {
    animation-delay: 0s;
}

#cf3 img:nth-child(2) {
    animation-delay: 6s;
}

#cf3 img:nth-child(3) {
    animation-delay: 12s;
}

.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /*    background-color: rgba(0, 0, 0, 0.5);*/
    background: linear-gradient(rgba(255, 255,255, 0.9),rgba(0, 0,0, 0.5),rgba(255, 5, 0, 0.11));
}

.form-card {
    width: 400px;
    margin-bottom: 0px !important;
   min-height: 300px;
   /* display: flex;
    justify-content: center; */
   /* flex-direction: column;*/
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7) !important;
    border-radius: 15px;
    box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.5);
    padding: 30px;
 /*   max-width: 400px;*/
}
.theme-form input[type="text"], 
.theme-form input[type="password"] {
  border-color: #efefef;
  font-size: 14px;
  color: #898989;
}
.form-card h2 {
    color: #111827;
    font-weight: 800;
    font-size: 30px;
    /* line-height: 0; */
    margin: 0;
}

.form-card h3 {
    color: #4B5563;
    font-weight: normal;
    font-size: 14px;
    margin-top: 1.5rem;
    margin-bottom: .8rem;
}

.line {
    height: 0;
    padding: 0;
    margin: 1px auto;
    border-radius: 50px;
    border: 2px solid #E41613;
    background-color: #E41613;
    width: 79px;
}

form {
    width: 100%;
}

.textfield {
    width: 100%;
    height: 56px;
    background: #FFFFFF;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin: 20px 0;
}

.divider {
    width: 0px;
    height: 10px;
    margin: 0 10px;
    border: 1px solid #E3E3E3;
    background-color: #E3E3E3;
}

.texticon {
    width: 15px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.textfield>input {
    flex: 1;
    height: 50px;
    border: none;
    outline: none;
    font-size: 15px;
    color: #000;
    font-weight: 100;
}

.textfield>input::placeholder {
    font-size: 15px;
    color: #A0A5AF;
    font-weight: lighter;
}
.textfield > select {
   
    border:none;
    text-align:center;
    width:100%;
}

/* .textfield #lock {
    width: 20px;
    height: 28px;
    align-items: center;
} */

.forgot {
    font-size: 15px;
    display: flex;
    justify-content: right;
    margin-top: 0px;
    margin-bottom: 10px;
    color: #111827;
    font-weight: 600;
    cursor: pointer;
}

.button {
    width: 100%;
    height: 55px;
    color: #fff;
    font-size: 18px;
    margin-top: 5px;
    border: none;
    outline: none;
    background-color: #E41613;
    border-radius: 10px;
    cursor: pointer;
}

.red {
    color: #E41613;
}

.red>a {
    cursor: pointer;
}

.register {
    color: #111827;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    padding: 1rem 0;
}

.white-divider {
    width: 200px;
    height: 0px;
    border: 0.1px solid #FFFFFF;
    display: flex;
    justify-content: center;
    margin: 2rem auto;
}

hr {
    border: none;
    height: .08px;
    width: 100%;
    color: #FFFFFF;
    background-color: #FFFFFF;
    margin: 1.5rem auto;
}

.copyright {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: #555555;
}
/*Loader */
.loader-box {
    height: 24px;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    vertical-align: middle;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;
    transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;
}

.loader-box [class*="loader-"] {
    display: inline-block;
    width: 50px;
    height: 50px;
    color: inherit;
    vertical-align: middle;
}


.loader-box .loader-15 {
    background: #a927f9;
    background: #df0000;
    position: relative;
    -webkit-animation: loader-15 1s ease-in-out infinite;
    animation: loader-15 1s ease-in-out infinite;
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
    width: 0.25em;
    height: 0.5em;
    margin: 0 0.5em;
}

    .loader-box .loader-15:after,
    .loader-box .loader-15:before {
        content: "";
        position: absolute;
        width: inherit;
        height: inherit;
        background: inherit;
        -webkit-animation: inherit;
        animation: inherit;
    }

    .loader-box .loader-15:before {
        right: 0.5em;
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
    }

    .loader-box .loader-15:after {
        left: 0.5em;
        -webkit-animation-delay: 0.6s;
        animation-delay: 0.6s;
    }

.loader-box .loader-in-control {
    position: absolute;
    top: 45px;
    right: 15px;
}

@-webkit-keyframes loader-15 {
    0%, 100% {
        -webkit-box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
        box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
    }

    50% {
        -webkit-box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
        box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
    }
}

@keyframes loader-15 {
    0%, 100% {
        -webkit-box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
        box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
    }

    50% {
        -webkit-box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
        box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
    }
}

.landing-success {
  /*  padding-bottom: 37px !important;
    font-size: 14px;*/
    color: green;
}

.landing-error {
  /*  padding-bottom: 37px !important;
    font-size: 14px;*/
    color: #e41f13;
}


@media only screen and (max-width: 1500px) {
    .forgot {
        font-size: 13px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .textfield>input {
        height: 50px;
        font-size: 16px;
    }
    .textfield>input::placeholder {
        font-size: 16px;
    }
    .textfield {
        width: 100%;
        height: 60px;
        margin: 20px 0;
    }
    .texticon {
        width: 18px;
        height: 26px;
    }
    .button {
        height: 50px;
        margin: 1rem 0;
    }
    .register {
        font-size: 13px;
        padding: .8rem 0;
    }
    hr {
        margin: 1.2rem auto;
    }
    .copyright {
        font-size: 12px;
    }
}

@media only screen and (max-width: 768px) {

    .form-card {
        width: 100%;
        min-height: 300px;
        /* display: flex;*/
        justify-items: center;
    /*    flex-direction: column;*/
        align-items: center; 
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 40px;
        box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.5);
        padding: 15px;
    }
}
.account-btn {
    color: #E41613; 
    cursor: pointer;
    font-weight: 500;
}
.select--text {
    font-size: 14px;
    margin-top: 4px;
}
.account__opening--section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #E41613;
    color: #fff;
    padding: 25px 25px 15px 25px;
    border-radius: 10px;
    cursor: pointer;
}
.login--section {
    margin-top: 20px;
}
.login--section p {
    font-size: 14px;
}
/* account opening */

.back-icon {
    margin-bottom: 6px;
   cursor: pointer;
   background-color: #E41613;
    border-radius: 50px;
    text-align: center;
   height: 30px;
   width: 30px;
   color: #fff
}
.feather-icon {
    color: #E41613;
    background-color: #FAE1DC;
    border-radius: 50px;
}
.header__bvn--text {
    text-align: center;
    color: #000;
    margin-bottom: 5px;
    letter-spacing: 0.4px;
    font-size: 1.2rem;
    font-weight: bold;
}
.bvn--subtext {
    font-size: 14px;
    text-align: center;
}
.side-content {
    margin-top: 15rem;
    /* transform: translate(-50%, -50%); */
}
.bvn-form input,
.bvn-form select {
  width: 100%;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #D9D9D9;
  padding: 0 10px;
  font-size: 16px;
  color: #000;
  margin-bottom: 15px;
}
select {
  width: 100%;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #D9D9D9;
  padding: 0 10px;
  font-size: 16px;
  color: #000;
}
.bvn-form input::placeholder {
    color: #ACACAC;
    font-size: 14px;
    font-weight: 300;
    text-align: left;
}
.bvn-form input[type=text]:focus,
.bvn-form input[type=email]:focus,
.bvn-form input[type=number]:focus,
.bvn-form input[type=password]:focus,
div >>> .otp-input:focus,
.answer-input:focus {
    outline: 1px solid #E41613;
    border: none;
}
/* .proceed-btn:disabled {
  background: gainsboro;
  cursor: not-allowed;
} */
/*.proceed-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
} */
.proceed-btn  {
    background-color: #E41613;
    color: #fff;
    border-radius: 10px;
    padding: 10px;
    height: 40px;
    width: 200px;
    font-size: 14px;
    margin-top: 5px;
    border: none;
}
div >>> .otp-input {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    padding: 0 10px;
    font-size: 16px;
    color: #000;
    margin-bottom: 10px;
    margin: 0 6px;
    text-align: center;
}
.request-otp {
    margin: 20px 0px;
    border: 1px solid #E41613;
    background: transparent;
    color: #E41613;
    border-radius: 10px;
    padding: 10px;
    height: 40px;
    font-size: 14px;
    width: 150px;
    margin: 30px 0px
}
.alt-means {
    color: #E41613;
    letter-spacing: 0;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}
.alt-means:hover {
    color: #E41613;
    text-decoration: none;
}
.bvn-form .row .form--input input::placeholder {
    text-align: left;
}
.form--input label {
    color: #2b2b2b;
    font-size: 13px;
}
.form--input input[type=date] {
    font-size: 14px;
    font-weight: 300;
    color: #ACACAC;
}
.form--input input[type=date]:invalid::-webkit-datetime-edit {
    color: #ACACAC;
    font-size: 14px;
    font-weight: 300;
    text-align: left;
}
.form--input input[type="date"]:focus {
    outline: 1px solid #E41613;
    border: none;
}
.form--input input[type=date] {
    width: 100%;
}
.form--input input[type=password] {
    width: 100%;
}
.form--input input[type=password]::placeholder{
    text-align: left;
}
.icon-eye {
    position: absolute;
    right: 10px;
    /* top: 12px; */
    margin-top: 12px;
    cursor: pointer;
}
.check-icon {
    background: #E7E7E9;
    padding: 10px;
    border-radius: 10px;
}
.q-header {
    color: #000000;
    font-size: 15px;
    font-weight: bold;
}
.question--subtext {
    color: #636364;
    font-size: 14px;
}
.main {
    position: absolute;
    top: 0;
}
.col h2 {
    font-size: 65px;
    margin-left: 60px;
}

/* accordion styles */
.fa-check {
    background-color: #D2CED5;
    color: #636364;
    padding: 12px;
    border-radius: 6px;
}
.card .card-header,
.card-header {
    background-color: transparent !important;
}
.answer-input {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    padding: 0 10px;
    font-size: 14px;
    color: #000;
}
div >>> .vs__dropdown-toggle {
    height: 50px !important;
    border-radius: 10px !important;
    background-color: #fff !important;
    margin-bottom: 10px !important;
}
.photo__wrapper {
    background-color: #DF351708;
    border: 3px solid #DF351712;
    border-radius: 10px;
    padding: 20px;
    height: 95px;
    width: 100%;
}
.photo-text {
    font-size: 16px;
}
.photo__wrapper >>> .feather-icon {
    color: #E41613;
    margin: 5px 0px;
}
.upload__wrapper {
    height: 80px;
    width: 80px;
    background-color: #DF351708;
    border: 3px solid #DF351712;
    border-radius: 15px;
    padding: 25px 0px;
}
.upload__wrapper >>> .feather__icon {
    color: #E41613;
}
.dropzone {
    border: 3px solid #DF351712 !important;
    min-height: 90px !important;
    width: 100% !important;
    background-color: #DF351708 !important;
    border-radius: 10px !important;
    margin: 0 auto !important;
}
.dropzone >>> .dz-default.dz-message {
    height: 0 !important;
}
.dropzone >>> i {
    font-size: 25px !important;
}
.bvn-form input[type=file] {
    border: 3px solid #DF351712 !important;
    background-color: #DF351708 !important;
    border-radius: 10px !important;
    width: 100%;
    height: 100px;
}

 .file-upload {
	position: relative;
	display: inline-block;
  width: 100%;
}
 .file-upload__label {
	display: block;
	border: 3px solid #DF351712 !important;
  background-color: #DF351708 !important;
  border-radius: 10px !important;
  width: 100%;
  height: 100px;
  padding: 30px 0px;
}
 .file-upload__label:hover {
	cursor: pointer;
}
 .file-upload__input {
	position: relative;
    display: none;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	font-size: 1;
	width: 0;
	height: 100%;
	opacity: 0;
}
.file-upload__label .icon-file {
    color: #E41613;
    font-size: 25px;
}
.error__text {
    color: #E41613;
    font-size: 14px;
    margin-top: -10px;
}
.welcome-wrapper .welcome-text {
  font-size: 23px;
  font-weight: 500;
  padding-bottom: 20px;
}
.welcome-subtext {
  font-size: 16px !important;
}
.accounts-details-title {
  font-size: 15px !important;
}
.accounts-details-subtitle {
  font-size: 20px !important;
  font-weight: 500 !important;
  color: #4B5563 !important;
}
@media screen and (max-width: 768px) {
  .nifi-logo {
    width: 100px;
    height: 80px;
    left: 0
  }
  .taj-logo {
    width: 150px;
    height: auto;
  }
  .overall-body {
    padding-bottom: 50px;
  }
  .login__header--text {
    font-size: 32px;
    margin-top: 0 !important;
  }
  .login__header--subtext {
    font-size: 17px;
  }
}
</style>